import { STATUS_LABELS } from '../../constants'
import { Flex, FlexProps, Badge } from 'theme-ui'
import { StatusType } from 'types'

export type ChipProps = FlexProps & {
  label?: string
  variant?: StatusType | 'TMLevel'
}

export function Chip({ label, variant = 'locked', ...rest }: ChipProps) {
  const badgeLabel =
    STATUS_LABELS[variant as keyof typeof STATUS_LABELS] ?? label
  return (
    <Flex {...rest}>
      <Badge variant={variant} data-cy={badgeLabel}>
        {badgeLabel}
      </Badge>
    </Flex>
  )
}
